import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckoutActions } from "../actions";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import { switchMap, map, catchError, of, takeUntil } from "rxjs";
import { LoggerService, tryNormalizeHttpError } from "@spartacus/core";

@Injectable()
export class CheckoutSubmitOrderEffects {

    protected logger = inject(LoggerService);

    constructor(
        private actions$: Actions,
        private apiService: ApiService,
    ) { }

    submitRequestOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.submitRequestOrder),
            switchMap(({ purchaseOrderNumber, cartGroupId }) => {
                return this.apiService.requestOrder(purchaseOrderNumber, cartGroupId)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map(() => CheckoutActions.submitOrderSuccess()),
                        catchError(error => of(CheckoutActions.submitOrderFail({
                            payload: tryNormalizeHttpError(error, this.logger)
                        })))
                    )
            })
        )
    );

    submitPlaceOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.submitPlaceOrder),
            switchMap(({ purchaseOrderNumber, cartGroupId, warehouseCartFlag }) => {
                return this.apiService.requestOrder(purchaseOrderNumber, cartGroupId)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map(() => warehouseCartFlag
                            ? CheckoutActions.submitApproveOrder({ purchaseOrderNumber, cartGroupId })
                            : CheckoutActions.submitOrderSuccess()),
                        catchError(error => of(CheckoutActions.submitOrderFail({
                            payload: tryNormalizeHttpError(error, this.logger)
                        })))
                    )
            })
        )
    );

    submitApproveOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.submitApproveOrder),
            switchMap(({ purchaseOrderNumber, cartGroupId }) => {
                return this.apiService.approveOrder(purchaseOrderNumber, cartGroupId)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map(() => CheckoutActions.submitOrderSuccess()),
                        catchError(error => of(CheckoutActions.submitOrderFail({
                            payload: tryNormalizeHttpError(error, this.logger)
                        })))
                    )
            })
        )
    ); 

    rejectOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CheckoutActions.rejectOrder),
            switchMap(({ cartGroupId, comment }) => {
                return this.apiService.rejectOrderRequest(cartGroupId, comment)
                    .pipe(
                        takeUntil(this.actions$.pipe(ofType(CheckoutActions.clearCheckoutState))),
                        map(() => CheckoutActions.rejectOrderSuccess({ cartGroupId })),
                        catchError(error => of(CheckoutActions.submitOrderFail({
                            payload: tryNormalizeHttpError(error, this.logger)
                        })))
                    )
            })
        )
    );
}